(function () {
  function initHeaderSpacerSync() {
    var section = document.getElementById('shopify-section-header');
    var spacer = document.querySelector('[data-header-spacer]');
    var siteHeader = section && section.querySelector('.site-header');
    if (!spacer || !siteHeader) return;

    function syncSpacerHeight() {
      if (!section.classList.contains('shopify-section-header-sticky')) return;
      var height = siteHeader.offsetHeight;
      if (!height) return;
      var currentHeight = parseFloat(window.getComputedStyle(spacer).height) || 0;
      if (Math.abs(currentHeight - height) < 2) return;
      spacer.style.height = height + 'px';
      document.documentElement.style.setProperty('--header-spacer-height', height + 'px');
    }

    requestAnimationFrame(syncSpacerHeight);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncSpacerHeight);
    }

    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(syncSpacerHeight);
      observer.observe(siteHeader);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderSpacerSync);
  } else {
    initHeaderSpacerSync();
  }
})();
